<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="1000px"
      :append-to-body="true"
      @close="$emit('update:visible', dialogVisible)">
      <div class="dialog-content-view">
        <h2>静态条码的风险及防范措施</h2>
        <p>静态条码指的是长期有效的条码，比如商家贴在柜台上的二维码。目前，静态条码被认为是风险最大的支付领域之一。</p>
        <h3>1.静态条码的风险</h3>
        <p>静态条码易被篡改或变造，易携带木马或病毒，真伪难辨，导致支付风险较高，容易造成商户资金受损。</p>
        <h3>2.防范措施</h3>
        <dl class="tip-two-dl">
          <dd>一、静态条码应采用防伪纸张展示条码，最好采用防护罩等物理防护手段避免条码被覆盖或替换，且使用防伪标签对防护罩进行标记；</dd>
          <dd>二、静态条码的介质应放置在收银员视线范围内，并定期对介质进行检查是否被替换；</dd>
          <dd>三、静态条码介质应放置在显著位置，且明显展示收款方信息，便于消费者核对；</dd>
          <dd>四、通过正规合法渠道下载收款软件，开启支付成功之后语音提示付款成功功能；</dd>
          <dd>五、要求消费者付款之后展示支付成功证明，在查看付款证明时应核对清楚收款方信息及收款金额等；</dd>
          <dd>六、经统计分析，“扫消费者付款码”的方式比“消费者扫静态条码”的方式更能防范风险，如条件允许，尽可能使用“扫消费者付款码”的方式进行收款；</dd>
        </dl>
        <h3>3.案例分析</h3>
        <p>收款码偷梁换柱</p>
        <p>案例：根据禅城公安通报，禅城公安分局祖庙派出所接群众报案，称自家店铺的营业收入被人盗窃，而盗窃的方式出乎众人意料。贼人通过粘贴替换二维码的方式将商家网上转账营业额据为己有。据店员描述，不法分子前来打包食物趁着店员工作之际，一名男子将事先准备好的一个二维码贴上商铺的收钱二维码上，随即扫描二维码进行付款。而贴上去的二维码就替换掉商家的二维码接受客户的付款，营业额全部转入了窃贼的钱包中。</p>
        <p>分析：要避免这种情况发生，各商家应妥善保管好店面的二维码账户名片，专门设一个接收付款的手机放在店里，养成当场查验习惯。改良贴二维码的支座，变透明或使用难以被张贴东西的材料制作。</p>
        <br>
        <p class="time">2018-9-27</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'qrWarningDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: this.visible
    }
  },
  watch: {
    visible (value) {
      this.dialogVisible = value
    }
  }
}
</script>

<style scoped>
.dialog-content-view h2 {
  text-align: center;
}
.tip-two-dl dd {
  margin-left: 0;
}
.time {
  text-align: right;
}
</style>
